// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Launcher$Showside from "../components/Launcher.bs.js";
import * as UseTracking$Showside from "../hook/UseTracking.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as LocationConfig$Showside from "../utils/LocationConfig.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as IntegrationUtils$Showside from "../utils/IntegrationUtils.bs.js";
import * as UseContextualL1s$Showside from "../hook/UseContextualL1s.bs.js";
import * as BottombarApp_Lazy$Showside from "./BottombarApp_Lazy.bs.js";
import * as EntrypointCallbacks$Showside from "../EntrypointCallbacks.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function LauncherApp(Props) {
  var configId = Props.configId;
  var onOpenLink = Props.onOpenLink;
  var attributes = Props.attributes;
  var embedType = Props.embedType;
  var className = Props.className;
  var match = LocationConfig$Showside.use(undefined);
  var namespace = match.namespace;
  RouterProvider$Showside.useRouter(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var trackEvent = UseTracking$Showside.use(embedType);
  var contextualRoot = UseContextualL1s$Showside.useContextualRoot(/* Open */2, embedType, window.location.pathname);
  var contextualL1s = UseContextualL1s$Showside.useContextualL1s(embedType, /* Open */2, window.location.pathname);
  var pageOnlyHasLauncher = IntegrationUtils$Showside.countInlineElementsByNamespace(namespace) === 0 && IntegrationUtils$Showside.countBottombarElementsByNamespace(namespace) === 0;
  var tmp = {
    config: match$1.config,
    embedType: embedType,
    children: React.createElement(Launcher$Showside.make, {
      categories: Belt_Array.keep(contextualL1s, function (category) {
        return category.visibleInMenuBar;
      }),
      centered: true,
      className: Cn.make([CSS$Showside.prefix("bg-main text-secondary"), Belt_Option.getWithDefault(className, CSS$Showside.prefix("py-4"))]),
      onTrackClick: function (param) {
        Curry.app(trackEvent, ["open", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      },
      theme: /* Main */0
    })
  };
  if (attributes !== undefined) {
    tmp.attributes = Caml_option.valFromOption(attributes);
  }
  if (contextualRoot !== undefined) {
    tmp.contextualRoot = Caml_option.valFromOption(contextualRoot);
  }
  var tmp$1;
  if (pageOnlyHasLauncher) {
    var tmp$2 = {
      configId: configId,
      embedType: embedType,
      enabled: false
    };
    if (onOpenLink !== undefined) {
      tmp$2.onOpenLink = Caml_option.valFromOption(onOpenLink);
    }
    if (attributes !== undefined) {
      tmp$2.attributes = Caml_option.valFromOption(attributes);
    }
    tmp$1 = React.createElement(BottombarApp_Lazy$Showside.make, tmp$2);
  } else {
    tmp$1 = null;
  }
  return React.createElement(React.Fragment, undefined, React.createElement(BaseWithTheme$Showside.make, {
    initiator: "launcher",
    portal: false,
    children: React.createElement(EntrypointCallbacks$Showside.make, tmp)
  }), tmp$1);
}
LauncherApp.displayName = "LauncherApp";
var make = React.memo(LauncherApp);
var $$default = make;
export { make, $$default, $$default as default };
/* make Not a pure module */